import { render } from "./PreschoolAcademicAssignmentsContent.vue?vue&type=template&id=88fd4574&ts=true"
import script from "./PreschoolAcademicAssignmentsContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolAcademicAssignmentsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__